const STROKE_COLOR = '#DDDDDD';

export default STROKE_COLOR;
